import { archivoNarrow } from './archivoNarrow.js';
import { opalBase } from './base.js';
import { cardo } from './cardo.js';
import { geist } from './geist.js';
import { inter } from './inter.js';
import { sourceSerif4 } from './sourceSerif4.js';
export const opalStyle = (family) => {
    if (family === 'Archivo Narrow') {
        return archivoNarrow;
    }
    if (family === 'Geist') {
        return geist;
    }
    if (family === 'Inter' ||
        family === 'GFS Neohellenic' ||
        family === 'Viga' ||
        family === 'Rajdhani' ||
        family === 'Jura' ||
        family === 'UnifrakturMaguntia' ||
        family === 'Grenze Gotisch' ||
        family === 'Bricolage Grotesque' ||
        family === 'Quicksand' ||
        family === 'Fredoka' ||
        family === 'Parkinsans' ||
        family === 'TikTok Sans') {
        return inter;
    }
    if (family === 'Cardo' ||
        family === 'Lora' ||
        family === 'Merriweather' ||
        family === 'Cinzel' ||
        family === 'Prata' ||
        family === 'Solway' ||
        family === 'Sanchez') {
        return cardo;
    }
    if (family === 'Source Serif 4') {
        return sourceSerif4;
    }
    return opalBase;
};
//# sourceMappingURL=index.js.map